import { atom } from 'recoil';

// Painel do assistente de IA aberto/fechado (não persiste entre recargas).
export const aiChatOpenState = atom({
  key: 'aiChatOpen',
  default: false,
});
